import {useEffect, useState} from "react";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import {CardActions, CardHeader, Snackbar, Stack, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {dateStrToDateObj, display24HourTime, toYYYYMMDD, dateToHumanDateStr} from "../../shared/date.js";
import Switch from "@mui/material/Switch";
import {Crumbs} from "../Crumbs.jsx";
import {Event} from "../../shared/type/event.ts";
import {toSlots} from "../../shared/class/event.ts";

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const Loading = () => <Card>
    <CardHeader title={"Loading Your Events"} />
    <CardContent>
        ...
    </CardContent>
</Card>

const NoEvents = () => <Card>
    <CardHeader title={"No Events Found"} />
    <CardContent>
        Click on the "Add New" Button above to add an event.
    </CardContent>
</Card>

export const AccountEventsPage = (props) => {

    const [eventList, setEventList] = useState([])
    const [loading, setLoading] = useState(true)
    const [displayPastEvents, setDisplayPastEvents] = useState(false)
    const [snackBarMessage, setSnackBarMessage] = useState(null)
    const [snackBarOpen, setSnackBarOpen] = useState(false)

    const loadEvents = () => {
        const token = window.localStorage.getItem("authToken");
        return fetch(`${BACKEND_HOST}/events/mine`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(res => res.map(e => Event.fromStrapi(e)))
        .then(res => setEventList(res))
        .then(() => setLoading(false));
    }

    useEffect(() => {
        loadEvents()

    }, [])

    const deleteEvent = async (documentId) => {
        const token = window.localStorage.getItem("authToken");
        fetch(`${BACKEND_HOST}/events/${documentId}`, {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(res => res.status === 204)
        .then(success => {
            if (success) {
                setSnackBarMessage("Event Deleted");
                setSnackBarOpen(true);
            } else {
                setSnackBarMessage("Delete Failed");
                setSnackBarOpen(true);
            }
        })
        .then(() => loadEvents());
    }
    const today = toYYYYMMDD(new Date())
    let eventListFiltered = eventList;
    if (displayPastEvents) {
        eventListFiltered = eventList.filter(e => e.date < today)
    } else {
        eventListFiltered = eventList.filter(e => e.date >= today)
    }

    const EventCards = () => eventListFiltered.map((e,i) =>
            <div style={{margin: "10px 0px 10px 0px"}} key={i}>
                <Card>
                    <CardHeader title={dateToHumanDateStr(dateStrToDateObj(e.date))} />
                    <CardContent>
                        <div>{e?.venue?.name}</div>
                        <div>{e.title}</div>
                        {toSlots(e.event_artists, e.event_instructors)
                            .map((s, j) => <div key={j}>{display24HourTime(s.time)} - {s.title}</div>)}
                        {/* {e.slots.map((s,j) => */}
                        {/*     <div key={j}>{s.localTime()} - {s.artist}</div> */}
                        {/* )} */}
                        {/* {e.event_artists.map((a,j) => */}
                        {/*     <div key={j}>{a.localTime()} - {a.artist}</div> */}
                        {/* {e.slots.map((s,j) =>
                            <div key={j}>{s.localTime()} - {s.artist}</div>
                        )} */}
                    </CardContent>
                    <CardActions>
                        <Button size={"small"} variant={"contained"} href={"/event/edit/" + e.documentId}>Edit</Button>
                        <Button size={"small"} color={"error"} onClick={() => deleteEvent(e.documentId)}>Delete</Button>
                    </CardActions>
                </Card>
            </div>)


    const EventCardContainer = () => {
        if (loading) {
            return <Loading />
        }
        if (eventList.length === 0) {
            return <NoEvents />
        }
        return <EventCards />
    }

    return <div>
        <Snackbar open={snackBarOpen} 
            message={snackBarMessage}
            autoHideDuration={2500}
            onClose={() => setSnackBarOpen(false)}
        />
        <Crumbs crumbs={[
            {title: "My Account"},
            {title: "Your Created Events"}
        ]} />
        <Card>
            <CardHeader title={"Events you created"} />
            <CardContent>
                These are the upcoming events you created. These are editable by you but not by other users.
            </CardContent>
            <CardActions>
                <Button size={"small"} variant={"contained"} href={"/event/edit/new"}>Add New</Button>
            </CardActions>
        </Card>
        <div>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Typography>Past</Typography>
                <Switch checked={!displayPastEvents} onClick={e => setDisplayPastEvents(!e.target.checked)} />
                <Typography>Upcoming</Typography>
              </Stack>
        </div>
        {!loading && <EventCardContainer />}
        </div>
}